import { useEffect, useState } from "react";
import SortBy from "../common/SortBy";

// PsykheSortBy component for sorting options in Psykhe PLP
const PsykheSortBy = ({ handleActiveSortOption, selected, seoData, isFilterBarFixed }) => {

    // Define sort options for Psykhe PLP
    const sortOptions = [
      {
        key: "psykhe",
        label: "Featured",
      },
      {
        key: "n_maxPrice_asc",
        label: "Price Low to High",
      },
      {
        key: "n_maxPrice_desc",
        label: "Price High to Low",
      },
    ];

  const [selectedSort, setSelectedSort] = useState(selected || sortOptions[0]); // Default sort option

  // Function to handle click on sort options
  const handleOptionsClick = (item) => {
    // Update the active sort option
    handleActiveSortOption(item);

    // Add the key property to the URL as a query parameter only if it is not empty
    if (item.key) {
      const url = new URL(window.location.href);
      url.searchParams.set("sort", item.key); // Add or update the 'sort' query parameter
      window.history.pushState({}, "", url.toString()); // Update the URL without reloading the page
    } else {
      const url = new URL(window.location.href);
      url.searchParams.delete("sort"); // Remove the 'sort' query parameter if the key is empty
      window.history.pushState({}, "", url.toString()); // Update the URL without reloading the page
    }

    if (typeof window !== "undefined" && window.scrollY > 0) {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  };

  // Set the active sort option based on the 'sort' query parameter in the URL
  useEffect(() => {
    const url = new URL(window.location.href);
    const sortParam = url.searchParams.get("sort");
    if (sortParam) {
      setSelectedSort(selected); // Update the selected sort option
    }
  }, [selected]);

  return (
    <SortBy
      sortOptions={sortOptions}
      handleOptionsClick={handleOptionsClick}
      selected={selectedSort} // Pass the selected sort option
      seoData={seoData}
      isFilterBarFixed={isFilterBarFixed}
    />
  );
};

export default PsykheSortBy;
